import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChatNotificationHistoryFilterEntity } from '../../domain/entities/ChatNotificationHistoryFilterEntity'

export class ChatNotificationHistoryFilterModel extends ChatNotificationHistoryFilterEntity {
  constructor(dataDto: ChatNotificationHistoryFilterModel) {
    super()
    mapEntityProperties<ChatNotificationHistoryFilterEntity>(this, dataDto)
  }
}
